import {ObjectUtils} from './object-utils';

export class StringUtils {
  public static readonly EMPTY = '';

  static equals(one: string, two: string): boolean {
    return one === two;
  }

  static isEmpty(value: string): boolean {
    return ObjectUtils.isNullOrUndefined(value) || StringUtils.equals(value, StringUtils.EMPTY);
  }
}
